import { useEffect } from "react";
import { NextStepProvider, NextStepReact } from "nextstepjs";
import TourCard from "shared/ui/tour/TourCard";
import useGetUserRole from "shared/hooks/useGetUserRole";

//types
import { ERoles } from "shared/types/roles";

//utils
import { tours } from "shared/utils/tours";

const StepTours = ({ children }: { children: React.ReactNode }) => {
  const role = useGetUserRole();
  const showTour = [ERoles.client, ERoles.credit_manager].includes(role);

  useEffect(() => {
    if (!showTour || localStorage.getItem("tours")) return;
    const tourKeys = tours.reduce(
      (acc, val) => ({ ...acc, [val.tour]: false }),
      {},
    );
    localStorage.setItem("tours", JSON.stringify(tourKeys));
  }, [showTour]);

  return (
    <NextStepProvider>
      <NextStepReact
        disableConsoleLogs={true}
        steps={showTour ? tours : []}
        cardComponent={TourCard}
      >
        {children}
      </NextStepReact>
    </NextStepProvider>
  );
};

export default StepTours;
